import React from 'react'
import { IntrigrationSec } from './intrigrationSec'

export const IntrigrationSubscriptionsUpdatePlan = () => {
  return (
    <>
    <IntrigrationSec /> 
    </>
  )
}
